export default {
  default: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/layouts/default.vue")
}